import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import CustomDataGrid from "../components/CustomDataGrid/CustomDataGrid.tsx";
import SweetAlertModal from "../components/SweetAlertModal/SweetAlertModal";
import LoadingView from "../components/LoadingView/LoadingView";
import AddRestaurantCreditDialog from "./AddRestaurantCreditDialog.tsx";
import TopHeader from "../../components/TopHeader.tsx";
import EditRestaurantCreditDialog from "./EditRestaurantCreditDialog.tsx";

function AddRestaurantCredit(props) {
  const [selectedDataRows, setSelectedDatarows] = React.useState([]);
  const [Loading, setLoading] = React.useState(false);
  const [dataRows, setDataRows] = useState([]);
  const apiAddress = process.env.REACT_APP_SECRET;
  const [openDialog, setopenDialog] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [restaurantCreditToUpdate, setRestaurantCreditToUpdate] = useState({});

  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };

  const loadData = async () => {
    setLoading(true); // Show loading indicator
    await axios.get(`${apiAddress}/api/Restaurant/GetAllRestaurantCredits`).then((response) => {
      const list = response.data.map((dt) => ({
        id: dt.id,
        restaurantId: dt.restaurantId,
        restaurantname: dt.restaurantName,
        credits: dt.credits,
        totalGivenCredits: dt.totalGivenCredits,
        fromDate: dt.fromDate, // ✅ Include fromDate
        toDate: dt.toDate,     // ✅ Include toDate
        isActive: dt.isActive,
        minimumOrderPrice: dt.minimumOrderPrice,
        creditLimitPerOrder: dt.creditLimitPerOrder,
      }));
      setDataRows(list);
    })
      .catch((error) => {
        toast.error("Failed to load restaurant credits.");
        console.error("Error loading data:", error);
      })
      .finally(() => {
        setLoading(false); // Hide loading indicator
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  const columns = [
    {
      field: "restaurantname",
      headerName: "Restaurant Name",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "credits",
      headerName: "Available Credits",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "totalGivenCredits",
      headerName: "Total Credits",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },

    {
      field: "minimumOrderPrice",
      headerName: "Minimum Order Price",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "creditLimitPerOrder",
      headerName: "Credit Limit Per Order",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "fromDate",
      headerName: "From Date",
      align: "center",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => new Date(params.value).toLocaleDateString(), // Format date
    },
    {
      field: "toDate",
      headerName: "To Date",
      align: "center",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => new Date(params.value).toLocaleDateString(), // Format date
    },
    {
      field: "isActive",
      headerName: "Active Status",
      align: "center",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => (
        <Switch
          checked={params.value}
          color="primary"
          inputProps={{ "aria-label": "toggle" }}
        />
      ),
    }
  ];

  const handleDialogOpen = () => {
    setopenDialog(true)
  }

  const handleDialogClose = () => {
    setopenDialog(false)
  }

  const OpenEditModal = async (RestaurantId) => {
    handleDialogClose();
    
    try {
      const result = await axios.get(`${apiAddress}/api/Restaurant/GetRestaurantCreditByRestaurantId/${RestaurantId}`);
      setRestaurantCreditToUpdate(result.data);

      if (result.data !== null) {
        setOpenEditModal(true);
      }
    }
    catch (error) {
      console.log("Error While fetching credit data by user id");
    }
  }

  return (
    <>
      <TopHeader />
      <div style={{ marginLeft: "2rem" }}>
        <LoadingView
          open={Loading}
          close={() => {
            setLoading(false);
          }}
        />
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mt={2}
          mb={2}
        >
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Button
                  color="primary"
                  size="medium"
                  variant="contained"
                  style={{ borderRadius: "50%", minWidth: "auto" }}
                  onClick={handleDialogOpen}
                >
                  +
                </Button>
                <AddRestaurantCreditDialog
                  open={openDialog}
                  existingData={dataRows}
                  onClose={handleDialogClose}
                  existingCredits={dataRows}
                  SetOpenEditModal={OpenEditModal}
                />
              </Grid>

            </Grid>
          </Grid>
        </Grid>

        <CustomDataGrid
          columns={columns}
          dataRows={dataRows}
          getselectedData={getselectedData}
          isLoading={Loading}
        />

        {openEditModal &&
          <EditRestaurantCreditDialog
            open={openEditModal}
            onClose={() => setOpenEditModal(false)}
            data={restaurantCreditToUpdate}
          />
        }
      </div>
    </>
  );
}
export default AddRestaurantCredit;